import { render, staticRenderFns } from "./FormRegis.vue?vue&type=template&id=3bd22e6d&"
import script from "./FormRegis.vue?vue&type=script&lang=js&"
export * from "./FormRegis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports